import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  TableCellLayout,
} from "@fluentui/react-components";
import '../CSS/ScopeListComponent.css';

const ScopeListComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Récupérer les scopes depuis Redux store
    const scopesData = useSelector(state => state.reducer.SCOPES);
    const scopesNames = useSelector(state => state.reducer.SCOPES_NAMES);
    const tenantId = useSelector(state => state.reducer.ACTIVE_TENANT);

    // État local
    const [loading, setLoading] = useState(true);

    // Transformer les données des scopes en liste avec stats
    const scopes = useMemo(() => {
        if (!scopesNames || scopesNames.length === 0) return [];

        // Si scopesNames est un tableau
        if (Array.isArray(scopesNames)) {
            return scopesNames.map((scopeName, index) => ({
                scope: scopeName,
                scopeKey: scopeName,
                callCount: 0,
                lastCallDate: null
            }));
        }

        // Si scopesNames est un objet
        if (typeof scopesNames === 'object') {
            return Object.entries(scopesNames).map(([key, name]) => ({
                scope: name,
                scopeKey: key,
                callCount: 0,
                lastCallDate: null
            }));
        }

        return [];
    }, [scopesNames]);

    useEffect(() => {
        if (scopesNames !== null) {
            setLoading(false);
        }
    }, [scopesNames]);

    console.log("Scopes data from Redux:", scopesData);
    const handleScopeClick = (scope) => {
        // Encoder le scope pour l'URL (remplace espaces par %20)
        const encodedScope = encodeURIComponent(scope);
        navigate(`/analytics/${encodedScope}`);
    };

    const columns = [
        { columnKey: "SCOPE_NAME", label: t("Entity") || "Entity" },
    ];

    if (loading) {
        return (
            <>
                <h4>{t('analytics.selectScope') || 'Sélectionner un scope'}</h4>
                <div className="scope-list-loading">
                    <p>{t('common.loading') || 'Chargement...'}</p>
                </div>
            </>
        );
    }

    if (scopes.length === 0) {
        return (
            <>
                <div className="scope-list-empty">
                    <p>{t('analytics.noScopes') || 'Aucun scope disponible'}</p>
                </div>
            </>
        );
    }

    return (
        <>
 <h2>{t("ANALYTICS")}</h2>
            <div className="scope-list-table-container">
               
                <div className="scope-list-table-wrapper">
                    <Table role="grid" aria-label="Scope table" className="scope-list-table-style">
                        {/* HEADER */}
                        {/* HEADER */}
                        <TableHeader>
                            <TableRow className="scope-list-header-style">
                                {columns.map((column) => (
                                    <TableHeaderCell
                                        key={column.columnKey}
                                        className="scope-list-cell-bold"
                                    >
                                        {column.label}
                                    </TableHeaderCell>
                                ))}
                            </TableRow>
                        </TableHeader>

                        {/* BODY */}
                        <TableBody>
                            {scopes.map((scopeData) => (
                                <TableRow 
                                    key={scopeData.scopeKey || scopeData.scope}
                                    onClick={() => handleScopeClick(scopeData.scope)}
                                    className="scope-list-row-clickable"
                                >
                                  
                                    <TableCell >
                                        <TableCellLayout>{scopeData.scope}</TableCellLayout>
                                    </TableCell>
                                
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </>
    );
};

export default ScopeListComponent;
